import { InjectionToken, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { EntityDocumentTreeModule } from './entity-document-tree/entity-document-tree.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { EnvironmentService } from './environment.service';
import { AppEnvironmentService } from './app-environment.service';
import { LayOutComponent } from './lay-out/lay-out.component';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faMinusSquare, faPlusSquare } from '@fortawesome/pro-light-svg-icons';
import { Configuration, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { MSAL_INSTANCE, MSAL_GUARD_CONFIG, MSAL_INTERCEPTOR_CONFIG, MsalService, MsalGuard, MsalBroadcastService, MsalModule, MsalInterceptor } from '@azure/msal-angular';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CountryNameReminderComponent } from './country-name-reminder/country-name-reminder.component';

export const APP_CONFIG = new InjectionToken<any>('AppConfig');
export function MSALInstanceFactory(config: Configuration): IPublicClientApplication {
  return new PublicClientApplication(config);
}

@NgModule({
  declarations: [
    AppComponent,
    LayOutComponent,
    CountryNameReminderComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FontAwesomeModule,
    HttpClientModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    EntityDocumentTreeModule,
    MsalModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: EnvironmentService,
      useClass: AppEnvironmentService,
      deps: [APP_CONFIG]
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: (config) => MSALInstanceFactory(config.msalConfig),
      deps: [APP_CONFIG]
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: (config) => config.msalGuardConfig,
      deps: [APP_CONFIG]
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: (config) => config.msalInterceptorConfig,
      deps: [APP_CONFIG]
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { 
  constructor(library: FaIconLibrary) {
    library.addIcons(faMinusSquare, faPlusSquare);
    
  }
}
